<div class="manage-address-container">
  <app-mobile-header [title]="'menu.manage.address'" [manualBackEvent]="true"
    (onManualBackEvent)="onClickBack()"></app-mobile-header>

  <app-address-list [savedAddress]="savedAddress" (editSelectedAddress)="editSelectedAddress($event)"
    [isProfilePage]="true">
  </app-address-list>
</div>
